import React, { Component } from 'react';
import NotificationService from '../services/NotificationService';
import PromotionsService from '../services/PromotionsService';
import PromotionTile from './PromotionTile';

export default class Promotions extends Component {
    classType = [
        {
            promo_tile: 'promo_tile',
            promo_tile_row: 'promo_tile_row promo_tile_value',
        },
        {
            promo_tile: 'promo_tile_disabled',
            promo_tile_row: 'promo_tile_row promo_tile_value_disabled',
        },
    ];
    constructor() {
        super();

        this.notificationService = NotificationService.getInstance();
        this.promotionsService = PromotionsService.getInstance();

        this.state = {
            obligatoryDataProvided: false,

            // all available promos
            promotions: [],

            // sequence of selected promos with combined promos at given level
            selectedPromotions: [],
        };

        this.userId = null;
        this.coursesHeadingsId = null;
        this.selectedProduct = null;

        this.selectedPaymentMethodDVID = null;
    }

    componentDidMount() {
  
        switch (this.props.selectedProduct.paymentTypesDVID) {
            case 1:
                this.props.selectedProduct.paymentDVIDName = 'z góry';
                break;
            case 2:
                this.props.selectedProduct.paymentDVIDName = 'ratalna';
                break;
        }

        if (typeof this.props.userId === 'number' && this.props.userId > 0) {
            this.userId = this.props.userId;
        }

        if (
            typeof this.props.courseHeading === 'object' &&
            this.props.courseHeading !== null &&
            typeof this.props.courseHeading.coursesHeadingsID === 'number' &&
            this.props.courseHeading.coursesHeadingsID > 0
        ) {
            this.coursesHeadingsId = this.props.courseHeading.coursesHeadingsID;
        }

        // this.props.selectedProduct.paymentDVIDName
        if (
            typeof this.props.selectedProduct === 'object' &&
            this.props.selectedProduct !== null &&
            typeof this.props.selectedProduct.productsID === 'number' &&
            this.props.selectedProduct.productsID > 0
            // typeof this.props.selectedProduct.paymentDVIDName === 'string' &&
            // this.props.selectedProduct.paymentDVIDName.length > 0
        ) {
            this.selectedProduct = this.props.selectedProduct;
        }

        let restoredPromotions = null;
        let restoredSelectedPromotions = null;
        if (
            typeof this.props.promotionsData === 'object' &&
            this.props.promotionsData !== null &&
            typeof this.props.promotionsData.promotions === 'object' &&
            Array.isArray(this.props.promotionsData.promotions) &&
            typeof this.props.promotionsData.selectedPromotions === 'object' &&
            Array.isArray(this.props.promotionsData.selectedPromotions)
        ) {
            restoredPromotions = this.props.promotionsData.promotions;
            restoredSelectedPromotions = this.props.promotionsData.selectedPromotions;
        }

        if (
            this.userId !== null &&
            this.coursesHeadingsId !== null &&
            this.selectedProduct !== null
        ) {
            let obj = { obligatoryDataProvided: true };
            if (restoredPromotions !== null && restoredSelectedPromotions !== null) {
                obj.promotions = restoredPromotions;
                obj.selectedPromotions = restoredSelectedPromotions;
            }
            this.setState(obj);
        }
    }

    loadPromotions(callback) {
        if (this.state.obligatoryDataProvided) {
            const inInstallments = this.selectedProduct.paymentDVIDName === 'ratalna';

            this.promotionsService.getPromotions(
                this.userId,
                this.coursesHeadingsId,
                this.selectedProduct.productsID,
                this.selectedPaymentMethodDVID,
                inInstallments,
                (response) => {
                    if (response.success) {
                        this.setState(
                            {
                                promotions: response.data,
                                selectedPromotions: [],
                            },
                            () => {
                                this.selectFirstAutoPromo(() => {
                                    if (typeof callback === 'function') {
                                        callback(true);
                                    }
                                });
                            }
                        );
                    } else {
                        if (typeof callback === 'function') {
                            callback(false);
                        }
                    }
                }
            );
        }
    }

    loadCombinedPromotions(promotionId, callback) {
        this.promotionsService.getCombinedPromotions(
            promotionId,
            this.coursesHeadingsId,
            this.selectedProduct.productsID,
            (response) => {
                if (response.success) {
                    // filter the ones that are present in this.state.promotions
                    const verifiedCombinedPromotionIds = [];
                    for (const promo of this.state.promotions) {
                        if (response.data.includes(promo.promotionsSalesID)) {
                            verifiedCombinedPromotionIds.push(promo.promotionsSalesID);
                        }
                    }

                    if (typeof callback === 'function') {
                        callback({ success: true, data: verifiedCombinedPromotionIds });
                    }
                } else {
                    if (typeof callback === 'function') {
                        callback({ success: false });
                    }
                }
            }
        );
    }

    selectPromo(promotionId, callback = null) {
        const updateState = (invokeCallback = false) => {
            // reload state
            this.setState({ selectedPromotions: this.state.selectedPromotions }, () => {
                if (invokeCallback && typeof callback === 'function') {
                    callback();
                }
            });
        };

        const obj = {
            promotionId: promotionId,
            combinedPromotionIds: [],
        };
        this.state.selectedPromotions.push(obj);

        // reload state
        this.setState({ selectedPromotions: this.state.selectedPromotions }, () => {
            this.emitPromotions();
        });

        this.loadCombinedPromotions(promotionId, (response) => {
            if (response.success) {
                obj.combinedPromotionIds = response.data;

                /* const combinedAutoPromos = [];
                for (const combinedPromo of response.data) {
                    inner: for (const promo of this.state.promotions) {
                        if (
                            combinedPromo === promo.promotionsSalesID &&
                            promo.activationTypeDVID === 2
                        ) {
                            combinedAutoPromos.push(combinedPromo);
                            break inner;
                        }
                    }
                }
                console.log('combinedAutoPromos', combinedAutoPromos);
                if (combinedAutoPromos.length > 0) {
                } else {
                } */

                updateState(true);
            } else {
                this.notificationService.showError();
            }
        });
    }

    unselectLastPromo() {
        this.state.selectedPromotions.pop();

        // reload state
        this.setState({ selectedPromotions: this.state.selectedPromotions }, () => {
            this.emitPromotions();
        });
    }

    selectFirstAutoPromo(callback = null) {
        let promoToSelectId = null;
        for (const promo of this.state.promotions) {
            if (promo.activationTypeDVID === 2) {
                promoToSelectId = promo.promotionsSalesID;
                break;
            }
        }

        if (promoToSelectId !== null) {
            this.selectPromo(promoToSelectId, callback);
        } else {
            callback(true);
        }
    }

    render() {
        if (this.state.obligatoryDataProvided) {
            return this.state.promotions.length > 0 ? (
                <>
                    <div id="active-promotions" className="active-promotions margin-top-64">
                        <h4 className="active-promotions__caption text-large fw-700">
                            <span>
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M6 6.60067H7.2M10.8 11.4007H12M12 6.00067L6 12.0007M8.1612 0.948671L6.8064 2.30107C6.58436 2.5235 6.28309 2.64868 5.9688 2.64907H3.8352C3.52076 2.64907 3.2192 2.77398 2.99685 2.99632C2.77451 3.21867 2.6496 3.52023 2.6496 3.83467V5.96827C2.6492 6.28256 2.52403 6.58383 2.3016 6.80587L0.948 8.16307C0.725746 8.3854 0.600891 8.6869 0.600891 9.00127C0.600891 9.31564 0.725746 9.61714 0.948 9.83947L2.304 11.1943C2.526 11.4163 2.6508 11.7175 2.6508 12.0319V14.1655C2.6508 14.8207 3.1812 15.3511 3.8364 15.3511H5.97C6.2844 15.3511 6.5856 15.4759 6.8076 15.6991L8.1636 17.0539C8.38593 17.2761 8.68743 17.401 9.0018 17.401C9.31617 17.401 9.61767 17.2761 9.84 17.0539L11.1948 15.6979C11.417 15.4759 11.7183 15.3511 12.0324 15.3511H14.166C14.4804 15.3511 14.782 15.2262 15.0043 15.0038C15.2267 14.7815 15.3516 14.4799 15.3516 14.1655V12.0319C15.3516 11.7175 15.4764 11.4163 15.6996 11.1943L17.0544 9.83827C17.2767 9.61594 17.4015 9.31444 17.4015 9.00007C17.4015 8.6857 17.2767 8.3842 17.0544 8.16187L15.6984 6.80707C15.4764 6.58483 15.3517 6.28359 15.3516 5.96947V3.83587C15.3516 3.52143 15.2267 3.21987 15.0043 2.99752C14.782 2.77518 14.4804 2.65027 14.166 2.65027H12.0324C11.7181 2.64987 11.4168 2.5247 11.1948 2.30227L9.8376 0.948671C9.61527 0.726417 9.31377 0.601563 8.9994 0.601562C8.68503 0.601563 8.38353 0.726417 8.1612 0.948671Z" />
                                </svg>
                            </span>
                            Aktywne promocje do umowy
                        </h4>

                        <p className="margin-top-8">Skorzystaj z promocji.</p>

                        <div className="active-promotions__checkboxes">
                            {this.renderPromotions()}
                        </div>
                    </div>

                    <div className="discount margin-top-64">
                        {/* <h4 className="discount__caption text-large fw-700">
                            <span>
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M6 6.60067H7.2M10.8 11.4007H12M12 6.00067L6 12.0007M8.1612 0.948671L6.8064 2.30107C6.58436 2.5235 6.28309 2.64868 5.9688 2.64907H3.8352C3.52076 2.64907 3.2192 2.77398 2.99685 2.99632C2.77451 3.21867 2.6496 3.52023 2.6496 3.83467V5.96827C2.6492 6.28256 2.52403 6.58383 2.3016 6.80587L0.948 8.16307C0.725746 8.3854 0.600891 8.6869 0.600891 9.00127C0.600891 9.31564 0.725746 9.61714 0.948 9.83947L2.304 11.1943C2.526 11.4163 2.6508 11.7175 2.6508 12.0319V14.1655C2.6508 14.8207 3.1812 15.3511 3.8364 15.3511H5.97C6.2844 15.3511 6.5856 15.4759 6.8076 15.6991L8.1636 17.0539C8.38593 17.2761 8.68743 17.401 9.0018 17.401C9.31617 17.401 9.61767 17.2761 9.84 17.0539L11.1948 15.6979C11.417 15.4759 11.7183 15.3511 12.0324 15.3511H14.166C14.4804 15.3511 14.782 15.2262 15.0043 15.0038C15.2267 14.7815 15.3516 14.4799 15.3516 14.1655V12.0319C15.3516 11.7175 15.4764 11.4163 15.6996 11.1943L17.0544 9.83827C17.2767 9.61594 17.4015 9.31444 17.4015 9.00007C17.4015 8.6857 17.2767 8.3842 17.0544 8.16187L15.6984 6.80707C15.4764 6.58483 15.3517 6.28359 15.3516 5.96947V3.83587C15.3516 3.52143 15.2267 3.21987 15.0043 2.99752C14.782 2.77518 14.4804 2.65027 14.166 2.65027H12.0324C11.7181 2.64987 11.4168 2.5247 11.1948 2.30227L9.8376 0.948671C9.61527 0.726417 9.31377 0.601563 8.9994 0.601562C8.68503 0.601563 8.38353 0.726417 8.1612 0.948671Z" />
                                </svg>
                            </span>
                            Kod rabatowy
                        </h4>
                        <p className="margin-top-8">Jeśli posiadasz kod rabatowy, użyj go.</p>
                        <div className="form__row margin-top-16">
                            <label htmlFor="discount" className="form__label">
                                Kod rabatowy
                            </label>
                            <input
                                type="text"
                                name="discount"
                                id="discount"
                                className="form__input"
                                title="Kupon rabatowy"
                            />
                            <div className="discount__confirm">
                                <button
                                    type="button"
                                    className="discount__btn btn-secondary-responsive btn-secondary-responsive--small margin-top-16"
                                >
                                    Zatwierdź kod
                                </button>
                            </div>
                        </div>
                        <p className="discount__message--error fw-700 margin-top-16">
                            Nie znaleziono kodu rabatowego
                        </p>
                        <p className="discount__message--succes fw-700 margin-top-16">
                            Rabat został przyznany
                        </p> */}
                    </div>
                </>
            ) : (
                ' '
            );
        } else {
            return <></>;
        }
    }

    renderPromotions() {
        return (
            <>
                <div className="form-row">
                    {this.state.promotions.map((promo, index) => {
                        const checkboxParams = this.getCheckboxParams(promo.promotionsSalesID);
                        if (checkboxParams.visible) {
                            return (
                                <p className="checkbox-group">
                                    <input
                                        type="checkbox"
                                        id={'active-promotion-' + promo.promotionsSalesID}
                                        name={'active-promotion-' + promo.promotionsSalesID}
                                        className="form__checkbox"
                                        checked={checkboxParams.checked}
                                        onChange={(e) => {
                                            this.promotionCheckboxClicked(promo.promotionsSalesID);
                                        }}
                                        // disabled={!checkboxParams.enabled}
                                        disabled={!checkboxParams.enabled}
                                    />

                                    <label
                                        htmlFor={'active-promotion-' + promo.promotionsSalesID}
                                        className="form__label--checkbox"
                                    >
                                        {promo.promotionsSalesName}
                                        {typeof promo.discounts === 'object' &&
                                        Array.isArray(promo.discounts) ? (
                                            <div>
                                                {promo.discounts.map((discount) => {
                                                    return (
                                                        <PromotionTile
                                                            classType={this.classType[0]}
                                                            discountData={discount}
                                                        ></PromotionTile>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </label>
                                </p>
                            );
                        } else {
                            return (
                                <p className="checkbox-group">
                                    {/* checkbox placeholder */}
                                    <div style={{ width: '20px', height: '20px' }}></div>

                                    <label className="form__label--checkbox">
                                        {promo.promotionsSalesName}
                                        {typeof promo.discounts === 'object' &&
                                        Array.isArray(promo.discounts) ? (
                                            <div>
                                                {promo.discounts.map((discount) => {
                                                    return (
                                                        <PromotionTile
                                                            classType={this.classType[1]}
                                                            discountData={discount}
                                                        ></PromotionTile>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </label>
                                </p>
                            );
                        }
                    })}
                </div>
            </>
        );
    }

    paymentMethodChanged(paymentMethodData) {
        if (
            typeof paymentMethodData === 'object' &&
            paymentMethodData != null &&
            typeof paymentMethodData.selectedPaymentMethod === 'number' &&
            paymentMethodData.selectedPaymentMethod > 0
        ) {
            this.selectedPaymentMethodDVID = paymentMethodData.selectedPaymentMethod;
        }

        this.loadPromotions((success) => {
            if (success) {
                this.emitPromotions();
            } else {
                // problem podczas pobierania danych użytkownika
                this.notificationService.showError();
            }
        });
    }

    getCheckboxParams(promotionId) {
        let visible = false;
        let checked = false;
        let enabled = false;

        if (this.state.selectedPromotions.length > 0) {
            let lastElement =
                this.state.selectedPromotions[this.state.selectedPromotions.length - 1];

            let selected = false;
            for (const selectedPromo of this.state.selectedPromotions) {
                if (selectedPromo.promotionId === promotionId) {
                    selected = true;
                    break;
                }
            }

            if (selected) {
                checked = true;
                visible = true;

                if (lastElement.promotionId === promotionId) {
                    // is last selected
                    enabled = true;
                } else {
                    // selected earlier
                    enabled = false;
                }
            } else {
                if (lastElement.combinedPromotionIds.includes(promotionId)) {
                    visible = true;
                    enabled = true;
                }
            }
        } else {
            // nothing selected => can click any promo
            visible = true;
            enabled = true;
        }

        return { visible, checked, enabled };
    }

    promotionCheckboxClicked(promotionId) {
        if (this.state.selectedPromotions.length > 0) {
            let lastElement =
                this.state.selectedPromotions[this.state.selectedPromotions.length - 1];

            let selected = false;
            for (const selectedPromo of this.state.selectedPromotions) {
                if (selectedPromo.promotionId === promotionId) {
                    selected = true;
                    break;
                }
            }

            if (selected) {
                if (lastElement.promotionId === promotionId) {
                    // we are last selected item => can unselect us
                    this.unselectLastPromo();
                }
            } else {
                if (lastElement.combinedPromotionIds.includes(promotionId)) {
                    // we are combined promo of last selected promo => can select us
                    this.selectPromo(promotionId);
                }
            }
        } else {
            // nothing selected => can select us
            this.selectPromo(promotionId);
        }
    }

    emitPromotions() {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange({
                promotions: this.state.promotions,
                selectedPromotions: this.state.selectedPromotions,
            });
        }
    }
}
